<template>
  <div class="bulma admin">
    <section class="hero is-fullheight">
      <div class="hero-body">
        <div class="container">
          <div class="columns is-centered is-vertical-aligned is-flex">
            <div class="column box is-one-third">

              <!-- notification -->
              <div v-if="notification.message" :class="'notification is-' + notification.type">
                <button class="delete" @click="hideNotifications"></button>{{notification.message}}
              </div>

              <!-- TheAdmin logo -->
              <div class="columns is-flex is-centered is-mobile logologin">
                <figure class="column is-9">
                  <router-link to="/"><img src="/static/img/logo.png" alt="TheAdmin logo"></router-link>
                </figure>
              </div>

              <!-- email -->
              <div class="field columns">
                <div class="control column">
                  <input type="email" class="input" placeholder="Courriel" v-model="email" @keyup.enter="login">
                </div>
              </div>

              <!-- password -->
              <div class="field columns">
                <div class="control column">
                  <input type="password" class="input" placeholder="Mot de passe" v-model="password" @keyup.enter="login">
                </div>
              </div>

              <!-- submit button -->
              <button type="submit" class="button is-info is is-fullwidth" @click="login">Connexion</button>
              <br />
              <p class="has-text-centered is-size-7">
                Pour récupérer votre mot de passe ou vos identifiants contactez-nous par courriel:
                <br />
                <a href="mailto:contact@thecompagnie.eu">contact@thecompagnie.eu</a>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import firebase from 'firebase'
import notifier from '@/admin/mixins/notifier'

export default {
  name: 'log-in',
  data () {
    return {
      email: '',
      password: ''
    }
  },
  mixins: [notifier],
  methods: {
    login () {
      // login to firebase with email and password
      firebase.auth().signInWithEmailAndPassword(this.email, this.password)
        .then((user) => {
          // redirect to the admin page
          this.$router.push('/admin')
        })
        .catch((error) => {
          // display an warning notification
          this.showNotification('warning', error.message)
        })
    }
  }
}

</script>

<style scoped>
.fields{
  margin-bottom: 0 !important;
  margin-top: 0 !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
  padding-bottom: 0 !important;
  padding-top: 0 !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
}
.columns{
  margin-bottom: 0 !important;
  margin-top: 0 !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
  padding-bottom: 0 !important;
  padding-top: 0 !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
}
.column{
  margin-bottom: 0 !important;
  margin-top: 0 !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
  padding-bottom: 0 !important;
  padding-top: 0 !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
}
.logologin{
  margin-bottom: 0 !important;
  margin-top: 0 !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
  padding-bottom: 1em !important;
  padding-top: 0 !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
}
.control{
  margin-bottom: 0 !important;
  margin-top: 0 !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
  padding-bottom: 1em !important;
  padding-top: 0 !important;
  padding-right: 0 !important;
  padding-left: 0 !important;
}
.box{
  margin-bottom: 0 !important;
  margin-top: 0 !important;
  margin-right: 0 !important;
  margin-left: 0 !important;
  padding-bottom: 2em !important;
  padding-top: 2em !important;
  padding-right: 2em !important;
  padding-left: 2em !important;
}
</style>



// WEBPACK FOOTER //
// src/admin/pages/Login.vue